<vs-dialog [config]="{ dialogContainerClass: 'max-w-[480px]' }">
  <vs-dialog-header
    [config]="{
      mode: 'simple',
      showDivider: true,

      icon: 'trash-01',
      iconTheme: 'warn',

      title: 'Remove Charge',
      subtitle: 'Are you sure you want to remove this charge? This action cannot be undone.'
    }"
  ></vs-dialog-header>

  <!-- Plain text on purpose: the description is user input. -->
  <div *ngIf="line" class="flex justify-between items-center gap-4 my-4 px-4 py-3 border rounded-lg text-sm">
    <p class="font-medium text-gray-900 truncate" data-testid="remove-charge-description">{{ line.description }}</p>
    <span class="text-gray-600 whitespace-nowrap">{{ formatAmount(line.requestedAmount) }}</span>
  </div>

  <div class="flex gap-2">
    <button vs-button appearance="outline" class="flex-1" (click)="close()">Back</button>
    <button vs-button theme="danger" class="flex-1" [disabled]="removing" (click)="remove()">Remove Charge</button>
  </div>
</vs-dialog>
